<template>
  <div class="mx-5">
    <p><strong>{{ $t('nothing-is-here') | capitalize }}</strong></p>
    <p>{{ $t('maybe-you-need-some-permissions') | capitalize }}</p>
  </div>
</template>

<script>

export default {
  name: 'MenuItemLoader',
};
</script>

<style scoped>

</style>
